import { twMerge } from 'tailwind-merge'

type Props = {
  children: React.ReactNode
  isInvalid: boolean
}
const FileCard = ({ children, isInvalid }: Props) => {
  return (
    <div
      className={twMerge(
        'rounded-md border border-neutral-200 bg-white px-3 py-2',
        isInvalid ? 'border-red-500' : ''
      )}
    >
      {children}
    </div>
  )
}

export default React.memo(FileCard)
